import PropTypes from 'prop-types'

import {AlertIcon, SparkleIcon} from './icons'

/**
 * The strip under the answer that explains what just happened with a refine
 * (TK-3204 AC 4.4, 5.2, 7.1–7.3). Errors that can be retried carry a
 * "Try again" action; the rest just say so. A note from another flow (the
 * Enrich interview) brings its own `onRetry`, which wins over the screen's.
 * `retryDisabled` holds Try again while the mic is busy, so a rewrite can't
 * race a transcript. An info note may carry one `action` of its own (the Undo
 * on "Your new recording replaces your current one.").
 */
const RefineNote = ({note, onRetry, retryDisabled = false}) => {
  if (!note) return null

  const isError = note.kind === 'error'

  return (
    <p className={`ls-ai-note${isError ? ' error' : ''}`} role='status'>
      {isError ? <AlertIcon /> : <SparkleIcon size={16} />}
      <span>{note.message}</span>
      {
        isError && note.retry &&
          <button className='ls-note-act' disabled={retryDisabled} type='button' onClick={note.onRetry || onRetry}>Try again</button>
      }
      {
        !isError && note.action &&
          <button aria-label={note.action.ariaLabel} className='ls-note-act' type='button' onClick={note.action.onAction}>{note.action.label}</button>
      }
    </p>
  )
}

RefineNote.propTypes = {
  note: PropTypes.shape({
    action: PropTypes.shape({ariaLabel: PropTypes.string, label: PropTypes.string.isRequired, onAction: PropTypes.func.isRequired}),
    code: PropTypes.string,
    kind: PropTypes.oneOf(['info', 'error']).isRequired,
    message: PropTypes.string.isRequired,
    onRetry: PropTypes.func,
    retry: PropTypes.bool
  }),
  onRetry: PropTypes.func,
  retryDisabled: PropTypes.bool
}

export default RefineNote
